module.exports = {"thumb-width-l": "300px", "thumb-width-m": "140px", "thumb-width-s": "72px", "thumb-s-spacing": "4px", "DISCOUNT": 0.05, "DISCOUNT_THRESHOLD": 2000};


// WEBPACK FOOTER //
// ./makosh/assets/front-end-vars-gen.js